<template>
  <div
    class="relative flex h-10 w-10 flex-none items-center justify-center gap-2.5 rounded-full bg-flush-orange"
  >
    <icon-base :icon="IconDealNotes" class="text-white" />
    <div
      v-if="noteType && noteIcons[noteType].icon"
      class="absolute -right-[9px] -bottom-[9px] flex h-6 w-6 rounded-full border-2 border-divider p-1"
      :class="noteIcons[noteType].icon?.class || null"
    >
      <icon-base
        :icon="noteIcons[noteType].icon?.component"
        width="12"
        height="12"
        :view-box="noteIcons[noteType].icon?.viewBox"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

import { NotableType } from "@/enums/dealActivity";

import IconBusiness from "@/components/icons/IconBusiness.vue";
import IconTelephone from "@/components/icons/IconTelephone.vue";
import IconDealNotes from "@/components/icons/dealNotes/DealNotes.vue";

import type { Note } from "@/models/notes";

const props = defineProps<{
  note: Note;
}>();

const noteIcons = {
  application: {
    icon: undefined,
  },
  business: {
    icon: {
      component: IconBusiness,
      viewBox: "0 0 16 16",
      class: "bg-secondary-purple text-white",
    },
  },
  call: {
    icon: {
      component: IconTelephone,
      viewBox: "0 0 16 16",
      class: "bg-secondary-green text-white",
    },
  },
};

const noteType = ref<NotableType | null>(
  props.note.notable_type ? NotableType[props.note.notable_type] : null
);
</script>
